/* Auto GRO v2 landing page behaviour. Vanilla, no dependencies, no theme APIs.

   Four behaviours: size selection, the "how do I measure" drawer, an AJAX
   add-to-cart, and the sticky price bar.

   The whole file is gated on `.arov2` existing, so dropping arov2.js on any
   other template is a no-op rather than a stray listener.

   The governing rule for this file: the buy button's plain href is ALWAYS a
   real, working cart permalink. Every enhancement here is allowed to improve
   on that href and never allowed to replace it with nothing. */
(function () {
  "use strict";

  if (!document.querySelector(".arov2")) return;

  var SIZE_SEL = ".arov2-size[data-variant]";
  /* Matches the variant id inside a cart permalink, wherever the path is
     rooted: "/cart/123:1", "https://shop.example.com/cart/123:1",
     "/en/cart/123:1?discount=X". Only the digits are replaced, so the root
     path, the quantity and any query string survive untouched. */
  var VARIANT_IN_HREF = /(\/cart\/)(\d+)/;

  var buy = document.getElementById("arov2-buy");

  /* ---- 1. size selection ------------------------------------------------ */

  function sizeButtons() {
    return document.querySelectorAll(SIZE_SEL);
  }

  function selectedVariantId() {
    var btns = sizeButtons();
    var i;
    for (i = 0; i < btns.length; i++) {
      if (btns[i].getAttribute("aria-pressed") === "true") {
        return btns[i].getAttribute("data-variant");
      }
    }
    /* No size control on the page, or none pressed: fall back to whatever the
       href already points at, which is the pre-selected variant. */
    if (buy) {
      var m = (buy.getAttribute("href") || "").match(VARIANT_IN_HREF);
      if (m) return m[2];
    }
    if (btns.length) return btns[0].getAttribute("data-variant");
    return "";
  }

  function applyVariantToHref(variantId) {
    if (!buy || !variantId) return;
    var href = buy.getAttribute("href") || "";
    if (VARIANT_IN_HREF.test(href)) {
      buy.setAttribute("href", href.replace(VARIANT_IN_HREF, "$1" + variantId));
    } else {
      /* The href was never a cart permalink. Give it one rather than leaving
         a button that goes nowhere. */
      buy.setAttribute("href", "/cart/" + variantId + ":1");
    }
  }

  /* Sizes without variants (see arov2-buy.liquid). Only when the buy button
     carries data-size-name does a size travel separately from the variant:
     as a line item property on the AJAX add, and as a cart attribute on the
     permalink. Without data-size-name both functions below do nothing, so a
     product with real size variants behaves exactly as before. */
  function sizeName() {
    return buy ? buy.getAttribute("data-size-name") || "" : "";
  }

  function selectedSize() {
    var btns = sizeButtons();
    var i;
    for (i = 0; i < btns.length; i++) {
      if (btns[i].getAttribute("aria-pressed") === "true") {
        return btns[i].getAttribute("data-size") || "";
      }
    }
    return "";
  }

  /* Replaces (or adds) "attributes[<name>]=<size>" in the href's query string
     and leaves every other parameter alone. Keys are compared decoded, so the
     "+" encoding Liquid's url_encode emits and the "%20" this emits are the
     same key. */
  function applySizeToHref(size) {
    var name = sizeName();
    if (!buy || !name || !size) return;
    var href = buy.getAttribute("href") || "";
    var q = href.indexOf("?");
    var base = q < 0 ? href : href.slice(0, q);
    var params = q < 0 ? [] : href.slice(q + 1).split("&");
    var want = "attributes[" + name + "]";
    var kept = [];
    var i, key;
    for (i = 0; i < params.length; i++) {
      if (!params[i]) continue;
      key = params[i].split("=")[0];
      try { key = decodeURIComponent(key.replace(/\+/g, " ")); } catch (e) { /* keep raw */ }
      if (key !== want) kept.push(params[i]);
    }
    kept.push(encodeURIComponent(want) + "=" + encodeURIComponent(size));
    buy.setAttribute("href", base + "?" + kept.join("&"));
  }

  function selectSize(chosen) {
    var btns = sizeButtons();
    var i;
    for (i = 0; i < btns.length; i++) {
      btns[i].setAttribute("aria-pressed", btns[i] === chosen ? "true" : "false");
    }
    applyVariantToHref(chosen.getAttribute("data-variant"));
    applySizeToHref(chosen.getAttribute("data-size"));
  }

  document.addEventListener("click", function (ev) {
    var target = ev.target;
    var btn = target && target.closest ? target.closest(SIZE_SEL) : null;
    if (btn) selectSize(btn);
  });

  /* ---- 2. measure drawer ------------------------------------------------ */

  var measureToggle = document.getElementById("arov2-measure-toggle");
  var measureDrawer = document.getElementById("arov2-measure-drawer");

  if (measureToggle && measureDrawer) {
    measureToggle.setAttribute("aria-expanded", measureDrawer.hidden ? "false" : "true");
    measureToggle.addEventListener("click", function () {
      measureDrawer.hidden = !measureDrawer.hidden;
      measureToggle.setAttribute("aria-expanded", measureDrawer.hidden ? "false" : "true");
    });
  }

  /* ---- 3. add to cart --------------------------------------------------- */

  /* The failure path is the DEFAULT path. preventDefault() is called only
     after every synchronous precondition for the AJAX route has been checked,
     so any missing piece simply lets the browser follow the permalink. Once
     the request is in flight the browser's navigation is already cancelled,
     so an async failure hands control back by navigating to that same href
     explicitly. There is no branch that ends with the user on this page and
     nothing happening. */
  if (buy) {
    buy.addEventListener("click", function (ev) {
      var href = buy.getAttribute("href") || "";
      var cartUrl, variantId, item, name, size;

      try {
        /* Modified clicks (new tab, download, middle click) and anything a
           prior handler already handled are none of our business. */
        if (ev.defaultPrevented) return;
        if (ev.button !== 0 && ev.button !== undefined) return;
        if (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;
        if (typeof window.fetch !== "function") return;

        cartUrl = buy.getAttribute("data-cart-url");
        if (!cartUrl) return;

        variantId = selectedVariantId();
        if (!variantId) return;

        item = { id: variantId, quantity: 1 };
        name = sizeName();
        size = name ? selectedSize() : "";
        if (name && size) {
          item.properties = {};
          item.properties[name] = size;
        }
      } catch (e) {
        return; /* href wins */
      }

      ev.preventDefault();

      var settled = false;
      function go(url) {
        if (settled) return;
        settled = true;
        window.location.href = url;
      }
      function fallback() {
        go(href || "/cart");
      }

      try {
        window.fetch(cartUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: [item] })
        }).then(function (res) {
          if (res && res.ok) go("/checkout");
          else fallback();
        })["catch"](fallback);
      } catch (e) {
        fallback();
      }
    });
  }

  /* ---- 4. sticky price bar ---------------------------------------------- */

  var bar = document.getElementById("arov2-stickybar");

  if (bar) {
    /* Show it once he has committed to the page: 60% of one screen of scroll.
       Suppress it only while the real button is on screen, where the bar
       would sit on top of it. */
    var buttonOnScreen = false;
    var threshold = Math.round(window.innerHeight * 0.6);

    /* Publish the bar's real height so the footer can clear it.

       The bar is position:fixed, so it sits on top of the page and used to
       cover the last ~35px of the footer -- which is where the "individual
       results may vary / not medical advice" disclaimer lives. Legal text
       being visually truncated is not a cosmetic bug.

       Measured rather than hard-coded because the bar's height depends on
       its content: adding the struck compare-price grew it, and any future
       line would grow it again. A constant would be correct until the next
       edit and then silently wrong. arov2.css carries a fallback for the
       window before the bar first appears, and for no-JS. */
    var barH = 0;
    function publishHeight() {
      var h = Math.round(bar.getBoundingClientRect().height);
      if (h > barH) {
        barH = h;
        document.documentElement.style.setProperty("--arov2-stickybar-h", h + "px");
      }
    }

    function update() {
      bar.hidden = !(window.scrollY > threshold) || buttonOnScreen;
      if (!bar.hidden) publishHeight();
    }

    if ("IntersectionObserver" in window && buy) {
      new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          buttonOnScreen = entries[i].isIntersecting;
        }
        update();
      }, { threshold: 0 }).observe(buy);
    }

    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", function () {
      threshold = Math.round(window.innerHeight * 0.6);
      update();
    }, { passive: true });

    update();
  }
}());
